import Text from '@components/base/Text'
import Modal from '@components/base/Modal'
import Box from '@components/base/Box'
import { Button } from '@components/inputs/Button'
import LoadingSpinner from '@components/base/LoadingSpinner'
import MiniNav from '@components/base/MiniNav'
import Wrapper from './Wrapper'
import FooterUnauthenticated from '@components/page/FooterUnauthenticated'
import BlackBaudIcon from '@public/images/BlackBaudIcon.svg'
import BlackBaudEventModal from '@components/event/BlackBaudEventModal'
import { Toaster } from 'react-hot-toast'
import SpaceCreationForm from 'pages/create-event/space-creation'
import { MdOutlineDone, MdOutlineFileCopy } from 'react-icons/md'
import { CreateEventStage } from '@libs/CreateEvent/CreateEventStage'
import {
  EventEditorProvider,
  useEventEditor,
} from '@libs/CreateEvent/useEventEditor'

const CreateEventLayoutContent = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const {
    blackBaudComparison,
    createEventStage,
    disableProgress,
    duplicateLoading,
    embedCode,
    embedCopied,
    eventActionsVisible,
    formData,
    handleConfirmPublish,
    handleCopyEmbedCode,
    handleDeleteEvent,
    handleDuplicateEvent,
    handleGoToStripeSettings,
    handlePublishRequest,
    handleSaveSelectionBlackBaud,
    items,
    loading,
    merchantLoading,
    profile,
    setCreateEventStage,
    setShowBlackBaudModal,
    setShowEmbedModal,
    setShowPublishConfirmation,
    setShowStripeRequiredModal,
    showBlackBaudModal,
    showEmbedModal,
    showPublishConfirmation,
    showStripeRequiredModal,
    stripeStatus,
  } = useEventEditor()

  if (createEventStage?.stage === CreateEventStage.Space) {
    return (
      <Wrapper
        requireAuth={true}
        showFooter={false}
        requireChat={false}
        className="h-screen"
        wrapperClasses="flex flex-col flex-1  transition-all'"
      >
        <Box className="-mt-[80px] overflow-x-hidden h-[calc(100vh)] relative">
          <Box className="flex justify-between items-center h-full">
            <Box
              className={`flex flex-col items-center mx-auto`}
              style={{ width: '90%' }}
            >
              <Text className={`text-2xl my-2 font-bold`}>
                Create an event Space
              </Text>
              <Box
                className={`flex flex-row justify-evenly space-x-2 overflow-x-auto`}
              >
                <SpaceCreationForm />
              </Box>
            </Box>
          </Box>
        </Box>
      </Wrapper>
    )
  }

  return (
    <Wrapper
      requireAuth={true}
      showFooter={false}
      requireChat={false}
      className="h-screen"
      wrapperClasses="flex flex-col flex-1  transition-all'"
    >
      <Box className="-mt-[80px] pt-[80px] overflow-x-hidden h-[calc(100vh)] relative">
          <Box className="px-4 md:px-20 lg:px-[156px]">
            <Box className="py-6 sm:py-6">
              <Box className="flex justify-between items-center">
                <Box className="text-2xl">
                  {window.location.href.includes('?id=') ? 'Edit' : 'Create'}{' '}
                  Event for {profile?.company ?? profile?.university}
                </Box>
                {eventActionsVisible && (
                  <>
                    <Button
                      className="ml-auto mr-4 min-w-[130px]"
                      onClick={() => setShowEmbedModal(true)}
                      title="Get embed code"
                      type="secondary"
                      size="medium"
                    />
                    <Button
                      onClick={handlePublishRequest}
                      title={
                        formData?.isPublished ? 'Published' : 'Publish Event'
                      }
                      type="success"
                      size="medium"
                      disabled={formData?.isPublished ?? false}
                      className="mr-4 min-w-[110px]"
                    />
                    <Button
                      className="min-w-[110px]"
                      confirmationModal={{
                        title: 'Confirm Event Duplication',
                        content:
                          'Are you sure you want to duplicate this event?',
                      }}
                      loading={duplicateLoading}
                      onClick={handleDuplicateEvent}
                      title="Duplicate"
                      type="secondary"
                      size="medium"
                      isInConfirmationModal={true}
                    />
                    <Button
                      className="ml-4 min-w-[110px]"
                      confirmationModal={{
                        title: 'Confirm Event Deletion',
                        content: 'Are you sure you want to delete this event?',
                      }}
                      onClick={handleDeleteEvent}
                      title="Delete"
                      type="danger"
                      size="medium"
                      isInConfirmationModal={true}
                    />
                    {/* Disabled Blackbaud - https://448-studio.atlassian.net/browse/FRM-920 */}
                    {/* {formData?.isPublished && !blackBaudError && ( */}
                    {/*   <Button */}
                    {/*     className="ml-4 min-w-[110px]" */}
                    {/*     onClick={openBlackBaudModal} */}
                    {/*     title="Sync" */}
                    {/*     type="blackbaud" */}
                    {/*     size="medium" */}
                    {/*     loading={loadingBlackBaud} */}
                    {/*     icon={ */}
                    {/*       <BlackBaudIcon */}
                    {/*         viewBox="0 0 58 58" */}
                    {/*         preserveAspectRatio="xMidYMid meet" */}
                    {/*         height="24px" */}
                    {/*         width="24px" */}
                    {/*       /> */}
                    {/*     } */}
                    {/*   /> */}
                    {/* )} */}
                    {/* {blackBaudError && ( */}
                    {/*   <Button */}
                    {/*     className="ml-4" */}
                    {/*     onClick={() => { */}
                    {/*       window.localStorage.setItem( */}
                    {/*         'Forumm_LastEventEdited', */}
                    {/*         eventId as string */}
                    {/*       ) */}
                    {/*       push('/organisation-settings') */}
                    {/*     }} */}
                    {/*     title="Session expired, Please Reconnect" */}
                    {/*     type="link" */}
                    {/*     size="medium" */}
                    {/*     loading={loadingBlackBaud} */}
                    {/*   /> */}
                    {/* )} */}
                  </>
                )}
              </Box>
              <MiniNav
                stage={createEventStage}
                setStage={setCreateEventStage}
                navItems={items}
                disabled={disableProgress}
              />
              {loading ? (
                <Box className="flex items-center justify-center w-full py-24">
                  <LoadingSpinner size="medium" />
                </Box>
              ) : (
                <>{children}</>
              )}
            </Box>
          </Box>
          <Toaster
            toastOptions={{
              className:
                'shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]',
              duration: 4000,
            }}
          />
          <BlackBaudEventModal
            show={showBlackBaudModal}
            setShow={setShowBlackBaudModal}
            data={blackBaudComparison}
            onSave={handleSaveSelectionBlackBaud}
          />
          <Modal
            title="Confirm Publish Event"
            show={showPublishConfirmation}
            setShow={setShowPublishConfirmation}
          >
            <Box>
              Are you sure you want to publish this event? This cannot be
              undone.
            </Box>
            <Box className="flex w-full space-x-4 mt-4">
              <Button
                onClick={() => setShowPublishConfirmation(false)}
                className="flex-1"
                title="Cancel"
                type="tertiary"
              />
              <Button
                onClick={handleConfirmPublish}
                className="flex-1"
                title="Confirm"
                type="danger"
              />
            </Box>
          </Modal>
          <Modal
            title="Stripe is required for paid tickets"
            show={showStripeRequiredModal}
            setShow={setShowStripeRequiredModal}
            className="max-w-2xl"
          >
            <Box className="flex flex-col gap-4 text-sm">
              <Box>
                This event includes paid tickets. Link and activate Stripe
                Connect in your organisation settings before publishing so
                attendees can pay securely.
              </Box>
              <Box className="rounded-lg border border-forumm-menu-border p-4">
                <Box className="font-semibold">Payment setup status</Box>
                <Box className="mt-2 opacity-80">
                  {merchantLoading
                    ? 'Checking Stripe status...'
                    : stripeStatus.isReady
                      ? 'Stripe is ready.'
                      : 'Stripe setup is incomplete.'}
                </Box>
              </Box>
              <Box className="flex flex-col gap-3 sm:flex-row sm:justify-end">
                <Button
                  title="Cancel"
                  type="tertiary"
                  onClick={() => setShowStripeRequiredModal(false)}
                />
                <Button
                  title="Open organisation settings"
                  type="primary"
                  onClick={handleGoToStripeSettings}
                />
              </Box>
            </Box>
          </Modal>
          <Modal
            title="Event Embed Code"
            show={showEmbedModal}
            setShow={setShowEmbedModal}
            className="max-w-3xl"
          >
            <Box className="flex flex-col gap-4 py-2">
              <Text className="text-sm" ignoreTheme>
                Add this HTML block wherever you want the registration form to
                appear.
              </Text>
              <textarea
                className="min-h-[220px] w-full resize-none rounded border border-forumm-menu-border bg-transparent p-4 font-mono text-sm"
                readOnly
                value={embedCode}
              />
              <Box className="flex justify-end">
                <Button
                  onClick={handleCopyEmbedCode}
                  title={embedCopied ? 'Copied' : 'Copy code'}
                  type="primary"
                  size="medium"
                  icon={embedCopied ? <MdOutlineDone /> : <MdOutlineFileCopy />}
                />
              </Box>
            </Box>
          </Modal>
        <FooterUnauthenticated transparent={false} />
      </Box>
    </Wrapper>
  )
}

const CreateEventLayout = ({ children }: { children: React.ReactNode }) => (
  <EventEditorProvider>
    <CreateEventLayoutContent>{children}</CreateEventLayoutContent>
  </EventEditorProvider>
)

export default CreateEventLayout
